<template>
  <div class="load-more">
    <button class="btn--white" @click="buttonCick">{{ label }}</button>
    <p v-if="error" class="load-more__error">{{ loadErrorMsg }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    buttonCick: {
      type: Function,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      loadErrorMsg: 'Error loading new posts!',
    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/elements/_load-more.scss';
</style>
